module.exports = __webpack_public_path__ + "img/contact.7045baef.jpg";